import React from 'react';
import { Image } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { GridItem } from '../../Grid';
import Lottie, { LottieAnimation } from '../../Lottie';
import ChevronBackground from '../ChevronBackground';
import { HeroPromo, HeroPromoProps, HeroWrapper } from '../HeroPromo';
import {
  AnimationWrapper,
  HeadingGridItem,
  HeadingWrapper,
  HeroGrid,
  ImageWrapper,
  MainImage,
} from './styles';

export type HeroSimpleWithBackgroundProps = {
  heading: string;
  image?: Image;
  animation?: LottieAnimation;
  marketingPromo?: HeroPromoProps;
} & ComponentProps;

type HeroImageProps = {
  animation?: LottieAnimation;
  image?: Image;
};

const HeroImage: React.FC<HeroImageProps> = ({ image, animation }) => {
  if (animation) {
    return (
      <AnimationWrapper>
        <Lottie animation={animation} />
      </AnimationWrapper>
    );
  }
  if (image) {
    return <MainImage image={image} shouldEagerLoad={true} />;
  }
  return null;
};

/** Banner with a chevron background and simple content */
const HeroSimpleWithBackground: React.FC<HeroSimpleWithBackgroundProps> = ({
  heading,
  image,
  animation,
  marketingPromo,
  ...props
}) => (
  <HeroWrapper {...componentProps(props)}>
    <ChevronBackground {...componentProps(props)}>
      <HeroGrid containsMarketingPromo={!!marketingPromo}>
        {(animation || image) && (
          <GridItem desktop={8} tabletLandscape={8}>
            <ImageWrapper>
              <HeroImage animation={animation} image={image} />
            </ImageWrapper>
          </GridItem>
        )}
        <HeadingGridItem desktop={4} tabletLandscape={4}>
          <HeadingWrapper>{heading}</HeadingWrapper>
        </HeadingGridItem>
      </HeroGrid>
    </ChevronBackground>
    {marketingPromo && <HeroPromo {...marketingPromo} />}
  </HeroWrapper>
);

export default applyComponentTheme(HeroSimpleWithBackground, 'HeroSimpleWithBackground');
